import React from "react";
const AuctionMoreCard = () => {
    return (
        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
            <div className="_spot_sec_card _nft_expnew_card">
                <div className="_spot_sec_card_inner">
                    <div className="_spot_sec_card_top">
                        <img src="assets/img/sp1.png" alt="" className="_spot_sec_card_top_img" />
                    </div>
                    <div className="_spot_sec_card_btm">
                        <div className="_spot_card_btm_prfl">
                            <div className="_spot_card_btm_prfl_img_wrap">
                                <img src="assets/img/spprfl1.png" alt=""
                                    className="_spot_card_btm_prfl_img" />
                                <img src="assets/img/spprfl2.png" alt=""
                                    className="_spot_card_btm_prfl_img" />
                            </div>
                            <div className="_spot_card_btm_like">
                                <span className="_spot_card_btm_like_main"><svg
                                    xmlns="http://www.w3.org/2000/svg" width="20" height="18"
                                    fill="none" viewBox="0 0 20 18">
                                    <path stroke="#808191" stroke-linecap="round"
                                        stroke-linejoin="round" stroke-width="1.728"
                                        d="M10.707 16.482a1.884 1.884 0 0 1-1.071 0c-2.506-.856-8.105-4.424-8.105-10.473 0-2.67 2.152-4.83 4.804-4.83 1.573 0 2.964.76 3.837 1.936a4.778 4.778 0 0 1 3.836-1.936c2.653 0 4.804 2.16 4.804 4.83 0 6.049-5.599 9.617-8.105 10.473Z" />
                                </svg>
                                </span>
                                <p className="_spot_card_btm_like_num">232</p>
                            </div>
                        </div>
                        <h4 className="_spot_card_btm_title">Abstract Cube #2000</h4>
                        <div className="_spot_card_btm_eth_wrap">
                            <img src="assets/img/eth2.svg" alt="" className="_spot_card_btm_eth" />
                            <p className="_spot_card_btm_eth_num">27.5 ETH 1/1</p>
                        </div>
                        <a href="#0" className="_spot_card_btm_buy">Buy Now</a>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AuctionMoreCard;